import { cva } from 'class-variance-authority';

export const linkVariants = cva(
  'block font-medium text-white transition-all duration-100 ease-linear',
  {
    variants: {
      size: {
        large: 'text-[30px] leading-[1.1] hover:underline xl:text-[32px]',
        medium: 'text-[24px] leading-[1.7] hover:underline',
        small: 'text-[16px] leading-[1.4em] text-[#FFFFFFAD] hover:text-white',
      },
    },
    defaultVariants: {
      size: 'medium',
    },
  },
);
